package com.rainbowclubs.rainbow.data.cache

import com.russhwolf.settings.Settings

class AuthCache constructor(
    private val settings: Settings,
) {
    var userUid: String?
        get() = settings.getStringOrNull(KEY_UID)?.takeIf { it.isNotBlank() }
        set(value) {
            val userId = value?.takeIf { it.isNotBlank() }
            if (userId == null) {
                settings.remove(KEY_UID)
            } else {
                settings.putString(KEY_UID, userId)
            }
        }

    fun clear() {
        settings.remove(KEY_UID)
    }

    fun hasSession(): Boolean = !userUid.isNullOrBlank()

    companion object {
        private const val KEY_UID = "auth_uid"
    }
}
